import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../../context/AuthContext';
import './LoginForm.css';

function RegisterForm({ onSuccess, onSwitchToLogin }) {
  const { register, loginWithGoogle } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError(null);
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    // Validation
    if (!formData.email || !formData.password || !formData.confirmPassword) {
      setError('Tous les champs sont obligatoires');
      setLoading(false);
      return;
    }

    if (!validateEmail(formData.email)) {
      setError('Le format de l\'email est incorrect');
      setLoading(false);
      return;
    }

    if (formData.password.length < 8) {
      setError('Le mot de passe doit contenir au moins 8 caractères');
      setLoading(false);
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      setLoading(false);
      return;
    }

    // Inscription
    const result = await register(formData.email, formData.password);

    if (result.success) {
      setSuccess(true);
      setFormData({ email: '', password: '', confirmPassword: '' });
    } else {
      setError(result.message);
    }

    setLoading(false);
  };

  if (success) {
    return (
      <div className="login-form-container">
        <h2>✅ Inscription réussie !</h2>
        <div className="alert-success">
          <p><strong>Félicitations !</strong></p>
          <p>Un email de vérification vous a été envoyé à l'adresse {formData.email}.</p>
          <p>Veuillez cliquer sur le lien dans l'email pour activer votre compte.</p>
        </div>
        <div className="form-footer" style={{ marginTop: '1.5rem' }}>
          <button 
            type="button" 
            onClick={onSwitchToLogin}
            className="btn-primary"
          >
            🔐 Se connecter
          </button>
        </div>
      </div>
    );
  }

  const handleGoogleSuccess = async (credentialResponse) => {
    setLoading(true);
    setError(null);
    const result = await loginWithGoogle(credentialResponse.credential);
    if (result.success) {
      if (onSuccess) onSuccess();
    } else {
      setError(result.message);
    }
    setLoading(false);
  };

  return (
    <div className="register-form-container">
      <h2>Inscription</h2>
      <p className="form-subtitle">Créez votre compte en quelques secondes</p>

      <div className="google-login-container">
        <GoogleLogin
          onSuccess={handleGoogleSuccess}
          onError={() => setError('Échec de l\'inscription Google')}
          text="signup_with"
          shape="rectangular"
          size="large"
          width="100%"
          locale="fr"
        />
      </div>

      <div className="auth-separator">
        <span>ou</span>
      </div>

      <form onSubmit={handleSubmit} className="auth-form">
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="votre@email.com"
            disabled={loading}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Mot de passe</label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="••••••••"
            disabled={loading}
            required
          />
          <div className="password-requirements">
            <strong>Exigences :</strong>
            <ul>
              <li>Minimum 8 caractères</li>
            </ul>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="confirmPassword">Confirmer le mot de passe</label>
          <input
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            placeholder="••••••••"
            disabled={loading}
            required
          />
        </div>

        {error && (
          <div className="alert-error">
            ❌ {error}
          </div>
        )}

        <button
          type="submit"
          className="btn-primary"
          disabled={loading}
        >
          {loading ? '⏳ Inscription...' : '🚀 S\'inscrire'}
        </button>
      </form>

      <div className="form-footer">
        <p>
          Déjà un compte ?{' '}
          <button 
            type="button" 
            onClick={onSwitchToLogin}
            className="link-button"
          >
            Se connecter
          </button>
        </p>
      </div>
    </div>
  );
}

export default RegisterForm;












